import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Flex,
  Text,
  Input,
  useColorModeValue,
  Button,
} from '@chakra-ui/react';
import { useState } from 'react';

export const InvitePartnerModal = ({
  isOpen,
  onClose,
  onSendInvite,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSendInvite: ({ to }: { to: string }) => void;
}) => {
  const [email, setEmail] = useState('');
  const textColor = useColorModeValue('navy.700', 'white');
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Invite Partner</ModalHeader>
        <ModalBody>
          <Flex direction="column" align="start" mt={6}>
            <Text color={textColor} fontWeight="700" mb={3}>
              Add your partners email address and invite them to join!
            </Text>
            <Flex position="relative" mb="10px" w="100%">
              <Input
                h="50px"
                w="100%"
                variant="main"
                borderRadius="65px"
                placeholder="Email address..."
                _placeholder={{ color: 'secondaryGray.500' }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button
            bg="white"
            _hover={{ bg: 'secondaryGray.300' }}
            onClick={onClose}
            borderRadius="70px"
            border="1px solid"
            borderColor="#EDEFF2"
            h="34px"
            mr={1}
          >
            Cancel
          </Button>
          <Button
            bg="brand.400"
            _hover={{ bg: 'brand.300' }}
            onClick={() => onSendInvite({ to: email })}
            ml={1}
            h="34px"
            borderRadius="70px"
          >
            Invite
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
